(function () {
  'use strict';

  /* ---------------- Scroll-reveal entrance animation ---------------- */
  function initReveal() {
    var els = document.querySelectorAll('[data-hp-reveal]:not(.is-visible)');
    if (!els.length) return;

    els.forEach(function (el) {
      var delay = el.getAttribute('data-hp-reveal-delay');
      if (delay) el.style.transitionDelay = delay + 'ms';
    });

    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15 });

    els.forEach(function (el) { observer.observe(el); });
  }

  /* ---------------- Carousel arrows ---------------- */
  function initCarousels() {
    document.querySelectorAll('[data-hp-carousel]').forEach(function (carousel) {
      var track = carousel.querySelector('[data-hp-carousel-track]');
      var prevBtn = carousel.querySelector('[data-hp-carousel-prev]');
      var nextBtn = carousel.querySelector('[data-hp-carousel-next]');
      if (!track) return;

      function scrollByPage(direction) {
        track.scrollBy({ left: direction * track.clientWidth, behavior: 'smooth' });
      }

      if (prevBtn) prevBtn.addEventListener('click', function () { scrollByPage(-1); });
      if (nextBtn) nextBtn.addEventListener('click', function () { scrollByPage(1); });

      function updateArrowState() {
        if (!prevBtn && !nextBtn) return;
        var maxScroll = track.scrollWidth - track.clientWidth;
        var atStart = track.scrollLeft <= 2;
        var atEnd = track.scrollLeft >= maxScroll - 2;
        if (prevBtn) prevBtn.classList.toggle('is-disabled', atStart);
        if (nextBtn) nextBtn.classList.toggle('is-disabled', atEnd || maxScroll <= 0);
      }

      var ticking = false;
      track.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () { updateArrowState(); ticking = false; });
      }, { passive: true });

      window.addEventListener('resize', updateArrowState);
      updateArrowState();

      /* Optional autoplay support: set data-hp-carousel-autoplay="true"
         on the carousel element to enable automatic paging. */
      if (carousel.getAttribute('data-hp-carousel-autoplay') === 'true') {
        var timer = setInterval(function () {
          var maxScroll = track.scrollWidth - track.clientWidth;
          if (track.scrollLeft >= maxScroll - 2) {
            track.scrollTo({ left: 0, behavior: 'smooth' });
          } else {
            scrollByPage(1);
          }
        }, 5000);
        carousel.addEventListener('mouseenter', function () { clearInterval(timer); });
      }
    });
  }

  /* ---------------- Video sound toggle ---------------- */
  function initSoundToggles() {
    document.querySelectorAll('[data-hp-video-sound]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var media = btn.closest('.hp-video-shop__media');
        var video = media ? media.querySelector('video') : null;
        if (!video) return;
        video.muted = !video.muted;
        var mutedIcon = btn.querySelector('.hp-icon-muted');
        var unmutedIcon = btn.querySelector('.hp-icon-unmuted');
        if (mutedIcon) mutedIcon.hidden = !video.muted;
        if (unmutedIcon) unmutedIcon.hidden = video.muted;
      });
    });
  }

  function init() {
    initReveal();
    initCarousels();
    initSoundToggles();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();